define( 'commons/global-help-configs/accordion-filter-config',[],function() {
    return [ 
             {
                 element: '.filter-container',
                 intro: 'This filter is a lightweight version of old filters.<br>' +
                        'It displays only most important fields, and provides an <b>additional panel</b> which contains the others.' + 
                        '<br>In addition, it provides the following features :' + 
                        '<br>&nbsp- current filter request display' +
                        '<br>&nbsp- drag and drop between additional and default fields' +
                        '<br>&nbsp- fields state (shown or hidden) live saving',
                 position : 'bottom'
             }
    ];
});
